var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-google-maps/~/lodash/_Symbol.js
// module id = 220
// module chunks = 0